import { render, staticRenderFns } from "./StoreMapPopover.vue?vue&type=template&id=19b216c8&"
import script from "./StoreMapPopover.vue?vue&type=script&lang=js&"
export * from "./StoreMapPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports